import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  CircularProgress,
  MenuItem,
  Select,
  Typography,
  Chip,
  Box,
  InputLabel,
  TextField,
  Autocomplete,
  Alert,
} from "@material-ui/core";
import { getAllUsers, getUsersByRole } from "../../actions";
import jwt from "jsonwebtoken";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function SearchUsersRole({
  label,

  apiString,
  name,
  placehold,
  formState,
  setNewFormState,
  changeHandler,
  required,
  disabled,
  classes,
  userRoleName,
}) {
  const [userData, setUserData] = useState([]);
  const [filteredUserData,setFilteredUserData ]= useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);

  const vendorCode =
    formState?.vendor_Code?.Vendor_Code ||
    formState?.Vendor?.Vendor_Code ||
    (typeof formState?.vendor_Code === "string" ? formState.vendor_Code : "");

  useEffect(() => {
    let cancelled = false;

    const loadDefaultUsers = () => {
      if (cancelled) return;
      setLoading(true);
      if (apiString === "All") {
        setErrorMessage("");
        getAllUsers(
          (data) => { if (!cancelled) setUserData(data); },
          (l) => { if (!cancelled) setLoading(l); }
        );
      } else {
        setErrorMessage("");
        getUsersByRole(
          apiString,
          (data) => { if (!cancelled) setUserData(data); },
          (l) => { if (!cancelled) setLoading(l); }
        );
      }
    };

    const loadVendorIRUsers = async () => {
      setLoading(true);
      try {
        const res = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/getUsersByVendorCode/${vendorCode}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
        });
        if (cancelled) return;

        const ids = res?.data?.users?.ids
          ? res.data.users.ids.split(",").map((s) => s.trim()).filter(Boolean)
          : [];
        const emails = res?.data?.users?.iR_Users
          ? res.data.users.iR_Users.split(",").map((s) => s.trim())
          : [];
        const loginId = String(user?.LoginId || "").trim();
        
        const isLoginIdInIds = loginId ? ids.includes(loginId) : false;
        if(!isLoginIdInIds && userRoleName === "IR") {
          setErrorMessage('Your login ID is not associated with this vendor. Please contact support.');
          setUserData([]);
        } else {    
        if (ids.length > 0) {
           setErrorMessage("");
          setUserData(ids.map((id, idx) => ({ userId: id, userName: emails[idx] || id })));
          setLoading(false);
        } else {
           setErrorMessage("");
          loadDefaultUsers();
        }}
      } catch (e) {
        if (!cancelled) loadDefaultUsers();
      }
    };

    if (apiString === "IR" && vendorCode) {
      loadVendorIRUsers();
    } else {
      loadDefaultUsers();
    }

    return () => { cancelled = true; };
  }, [apiString, vendorCode]);
  useEffect(()=>{
    const selectedUserIds = formState.add_Reviser;
    const newFilteredData = userData?.filter(user => !selectedUserIds?.includes(user?.userId));
    setFilteredUserData(newFilteredData);
  },[formState])

  useEffect(()=>{
    setFilteredUserData(userData)
  },[userData])

  return (
    <div>
      {errorMessage && (
        <Alert severity="error" style={{ marginBottom: "10px" }}>
          {errorMessage}
        </Alert>
      )}
      <Typography style={{ color: "black" }}>
        {label}:{required ? <span className={classes.asterisk}>*</span> : null}
      </Typography>

      <Autocomplete
        sx={{
          "& .MuiInputBase-root": {
            height: "30px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiInputBase-input": {
            marginTop: "-4px", // Adjust this value to move the text up
            fontSize: 15
          },
        }}
        size="small"
        style={{ width: "100%" }}
        disabled={disabled}
        name={name}
        value={userData.find((user) => user?.userId === formState[name]) || ""}
        onChange={(event, newValue) => {
          setNewFormState((prevState) => ({
            ...prevState,
            [name]: newValue?.userId || "",
          }));
        }}
        // options={userData}
        options={filteredUserData.filter(user => user)} 
        getOptionLabel={(option) =>
          option
            ? apiString === "All"
              ? `${option?.username}`
              : `${option?.userName}`
            : ""
        }
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            // variant="standard"
            size="small"
            required={required}
            placeholder="select a user"
          />
        )}
      />
    </div>
  );
}

export default SearchUsersRole;
